export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const REFRESH_SUCCESS = 'REFRESH_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const USER_LOADED_SUCCESS = 'USER_LOADED_SUCCESS';
export const USER_LOADED_FAIL = 'USER_LOADED_FAIL';
export const AUTHENTICATED_SUCCESS = 'AUTHENTICATED_SUCCESS';
export const SET_MAINTENANCE_STATUS = 'SET_MAINTENANCE_STATUS';
export const AUTHENTICATED_FAIL = 'AUTHENTICATED_FAIL';
export const LOGOUT = 'LOGOUT';
export const ADD_ITEMS_TO_QUEUE = 'ADD_ITEMS_TO_QUEUE';
export const UPDATE_QUEUE_PROGRESS = 'UPDATE_QUEUE_PROGRESS';
export const UPDATE_SHOW_DOWNLOAD_MANAGER = 'UPDATE_SHOW_DOWNLOAD_MANAGER';
export const CLEAR_QUEUE_PROGRESS = 'CLEAR_QUEUE_PROGRESS';
export const REMOVE_ITEMS_FROM_QUEUE = 'REMOVE_ITEMS_FROM_QUEUE';
